import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HelpText from '../__partials/help-text';
import Label from '../__partials/label';
import idGenerator from '../../__utils/idGenerator';

const Input = ({
  type,
  name,
  label,
  hideLabel,
  required,
  disabled,
  hasError,
  helpText,
  hasDivider,
  className,
  qaId,
  inputRef,
  ...props
}) => {
  // We need to ensure that if a name is not included, we autogenerate
  // one so that the label and input are connected.
  let newName = name;

  if (!newName) {
    newName = idGenerator();
  }

  const formItemClasses = classNames('uni-form__item', 'l-grid__item', {
    'uni-form__item--is-error': hasError,
    'uni-form__item--is-disabled': disabled,
    'uni-form__item--has-divider ': hasDivider,
    [className]: className,
  });

  const formInputClasses = classNames({
    'uni-form__input': type !== 'file' && type !== 'date' && type !== 'time',
    'uni-form__input--file': type === 'file',
    'uni-form__input--date': type === 'date',
    'uni-form__input--time': type === 'time',
  });

  return (
    <div className={formItemClasses}>
      <Label label={label} name={newName} required={required} hideLabel={hideLabel} />

      <div className="uni-form__control l-form__control">
        <input
          type={type}
          className={formInputClasses}
          aria-describedby={newName + 'Help'}
          id={newName}
          disabled={disabled}
          data-qa-id={qaId}
          ref={inputRef}
          {...props}
        />
      </div>

      {helpText ? <HelpText name={newName} text={helpText} /> : null}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'number', 'date', 'time', 'email', 'password', 'url', 'tel', 'range', 'file']),
  name: PropTypes.string,
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  hasDivider: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  className: PropTypes.string,
  qaId: PropTypes.string,
  inputRef: PropTypes.func,
};

Input.defaultProps = {
  type: 'text',
  hasError: false,
  hideLabel: false,
  hasDivider: false,
};

export default Input;



// WEBPACK FOOTER //
// ./src/forms/input/index.jsx